export default __webpack_public_path__ + "static/media/live-mobile.22ae78df.svg";